module.exports = __webpack_public_path__ + "static/media/6.17_preview.31add511.png";